import React from "react";
import { Divider } from "@mui/material";
import { useParams } from "react-router-dom";
import "./organizationpage.styles.scss";
import OrganizationComponent from "../../components/organizations/organization.component";
import CustomDrawer from "../../components/drawer/drawer.component";

const OrganizationPage = () => {
  let { section } = useParams();

  return (
    <div className="organization">
      <CustomDrawer section={"organizations"} />
      <Divider orientation="vertical" className="divider" />
      <div className="component">
        <OrganizationComponent />
      </div>
    </div>
  );
};

export default OrganizationPage;
